import { render, staticRenderFns } from "./accountStatements.vue?vue&type=template&id=32ff90d8&scoped=true"
import script from "./accountStatements.vue?vue&type=script&lang=js"
export * from "./accountStatements.vue?vue&type=script&lang=js"
import style0 from "./accountStatements.vue?vue&type=style&index=0&id=32ff90d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ff90d8",
  null
  
)

export default component.exports